import { DateTime } from "luxon";
import React from "react";
import { useTranslation } from "react-i18next";
import { VelavuRoute, VelavuRouteDetailed } from "velavu-js-api";
import IconArrowThinRight from "../../../../dynamicicons/icon-arrow-thin-right";
import IconCar from "../../../../dynamicicons/icon-car";
import HoverTooltip from "../../../../elements/hover-tooltip";
import routeIcon from "../../../../img/route_icon.svg";
import * as styles from "./device-routes-item.module.scss";
import whitelabel from "../../../../whitelabel";

interface DeviceRouteItemProps {
	route: VelavuRoute;
	details?: VelavuRouteDetailed;

	isHovered: boolean;
	onHover: VoidFunction;
	onHoverExit: VoidFunction;

	isSelected: boolean;
	onSelect: (route: VelavuRoute | undefined) => void;
}

export default function DeviceRoutesItem(props: DeviceRouteItemProps) {
	const { t } = useTranslation();
	const dateStart = DateTime.fromISO(props.route.data.time_start);
	const dateEnd = props.route.data.time_stop
		? DateTime.fromISO(props.route.data.time_stop)
		: undefined;

	let selectionIndicatorStyle;
	if (props.isSelected)
		selectionIndicatorStyle = styles.selectionIndicatorVisible;
	else if (props.isHovered)
		selectionIndicatorStyle = styles.selectionIndicatorHover;
	else selectionIndicatorStyle = "";

	return (
		<div
			className={styles.container}
			onClick={() => {
				if (props.isSelected) {
					props.onSelect(undefined);
				} else if (props.route.data.location_start) {
					props.onSelect(props.route);
				}
			}}
			onMouseEnter={() =>
				props.route.data.location_start && props.onHover()
			}
			onMouseLeave={props.onHoverExit}
		>
			<div
				className={`${styles.selectionIndicator} ${selectionIndicatorStyle}`}
			/>

			<span className={styles.routeIcon}>
				<img src={routeIcon} />
			</span>
			<div className={`${styles.routeTwoLevel} ${styles.routePoints}`}>
				<span>{props.route.data.location_start}</span>
				{props.route.data.location_stop ? (
					<span>{props.route.data.location_stop}</span>
				) : (
					<span className={styles.inProgress}>
						{t("dashboard.routes.in_progress")}
					</span>
				)}
			</div>
			<div className={`${styles.routeTwoLevel} ${styles.routeTime}`}>
				<HoverTooltip
					delay={0}
					tooltip={
						!dateEnd ? (
							dateStart.toLocaleString(DateTime.DATETIME_MED)
						) : (
							<div className={styles.routeTimeTooltip}>
								<span className={styles.routeTimeTooltipDate}>
									{dateStart.toLocaleString(
										DateTime.DATE_FULL,
									)}
								</span>

								<span>
									{dateStart.toLocaleString(
										DateTime.TIME_SIMPLE,
									)}
								</span>
								<IconArrowThinRight color="white" />
								<span>
									{dateEnd.toLocaleString(
										DateTime.TIME_SIMPLE,
									)}
								</span>
							</div>
						)
					}
				>
					<span>
						{dateStart.toLocaleString(DateTime.TIME_SIMPLE)}
					</span>
				</HoverTooltip>
				<span className={styles.eventCount}>
					{props.isSelected ? (
						dateEnd?.toLocaleString(DateTime.TIME_SIMPLE)
					) : props.route.data.event_cnt > 0 ? (
						<>
							<IconCar
								size={16}
								color={whitelabel.palette.secondary700}
							/>
							<span className={styles.eventCountText}>
								{props.route.data.event_cnt}
							</span>
						</>
					) : null}
				</span>
			</div>
		</div>
	);
}
